import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useHistory } from 'react-router-dom';

import {loadPromoFilm, loadListFilms} from '../../../store/actions/api-actions/api-actions';
import {getListPromoFilm, getListFilms, getIsDataPromoFilmLoaded, getIsDataFilmsLoaded} from '../../../store/reducer/film-data/selectors';
import ListGenres from '../../common/ListGenres/ListGenres';
import Header from '../../common/Header/Header';
import Footer from '../../common/Footer/Footer';
import BtnMyList from '../../common/BtnMyList/BtnMyList';
import Loader from '../../common/Loader/Loader';

function Main() {
  const history = useHistory();
  const dispatch = useDispatch();

  const promoFilm = useSelector(getListPromoFilm);
  const isDataPromoFilmLoaded = useSelector(getIsDataPromoFilmLoaded);
  const listFilms = useSelector(getListFilms);
  const isDataFilmsLoaded = useSelector(getIsDataFilmsLoaded);

  React.useEffect(() => {
    if(!isDataFilmsLoaded || !isDataPromoFilmLoaded) {
      dispatch(loadListFilms());
      dispatch(loadPromoFilm());
    }
  }, [dispatch, isDataFilmsLoaded, isDataPromoFilmLoaded]);

  if (!isDataPromoFilmLoaded) {
    return <Loader/>;
  }

  return (
    <>
      <section className="film-card">
        <div className="film-card__bg">
          <img src={promoFilm.backgroundImage} alt={promoFilm.name} />
        </div>

        <h1 className="visually-hidden">WTW</h1>

        <Header />

        <div className="film-card__wrap">
          <div className="film-card__info">
            <div className="film-card__poster">
              <img src={promoFilm.posterImage} alt={promoFilm.name} width="218" height="327" />
            </div>

            <div className="film-card__desc">
              <h2 className="film-card__title">{promoFilm.name}</h2>
              <p className="film-card__meta">
                <span className="film-card__genre">{promoFilm.genre}</span>
                <span className="film-card__year">{promoFilm.released}</span>
              </p>

              <div
                className="film-card__buttons"
              >
                <button
                  className="btn btn--play film-card__button"
                  type="button"
                  onClick={() => history.push(`/player/${promoFilm.id}`)}
                >
                  <svg viewBox="0 0 19 19" width="19" height="19">
                    <use xlinkHref="#play-s"></use>
                  </svg>
                  <span>Play</span>
                </button>

                <BtnMyList id={promoFilm.id} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="page-content">
        <section className="catalog">
          <h2 className="catalog__title visually-hidden">Catalog</h2>

          <ListGenres listFilms={listFilms} />
        </section>

        <Footer />
      </div>
    </>
  );
}

export default Main;
